import { t } from "i18next"

const pipelineSummaryTransformer = response => {
  return { summary: response?.summary?.summary, lastUpdated: response?.latestSyncDate }
}

const barChartData = []?.flatMap(user => {
  const stacks = {
    Sold: { current: user?.sold, forecasted: user?.sold },
    "Partial Sold": { current: user?.partiallySold, forecasted: user?.partiallySold },
    "Token/Preclosure": { current: user?.preclosure },
    "Forecasted Probability": { forecasted: user?.forecastedRevenue },
  }

  const COLUMN_ORDER = {
    current: ["Sold", "Partial Sold", "Token/Preclosure"],
    forecasted: ["Sold", "Partial Sold", "Forecasted Probability"],
  }

  return ["current", "forecasted"].flatMap(column =>
    COLUMN_ORDER[column].map(type => {
      return {
        name: user?.name,
        column,
        type,
        value: stacks[type]?.[column] ?? 0,
      }
    })
  )
})

const pipelineForcastedWidgetTransformer = response => {
  const { data = [], currentPipeline, forecastedPipeline } = response || {}
  const barChartData = data
    ?.map(user => {
      const sold = user?.sold ?? 0
      const partialSold = user?.partiallySold ?? 0
      const preclosure = user?.preclosure ?? 0
      const forecasted = user?.forecastedRevenue ?? 0

      return [
        {
          name: user?.name,
          column: "total",
          type: "Active Sales Pipeline",
          value: sold + partialSold + preclosure,
          division: { sold, partialSold, preclosure, forecasted },
          totalSum: sold + partialSold + preclosure,
          forcastedSum: sold + partialSold + forecasted,
        },
        {
          name: user?.name,
          column: "forecasted",
          type: "Forecasted Pipeline",
          value: sold + partialSold + forecasted,
          division: { sold, partialSold, preclosure, forecasted },
          totalSum: sold + partialSold + preclosure,
          forcastedSum: sold + partialSold + forecasted,
        },
      ]
    })
    .flat()

  return {
    barChartData: data?.length ? barChartData : [{ name: t("No Staff") }],
    currentPipeline,
    forecastedPipeline,
  }
}

export const pipelineReportTransformer = (response, args) => {
  if (args?.load === "summary") return pipelineSummaryTransformer(response)
  else if (args?.load === "forecasted_widget") return pipelineForcastedWidgetTransformer(response?.forecastedWidget)
}
